import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import BreadcrumbsContext from './BreadcrumbsContext';

export class Breadcrumbs extends React.PureComponent {
  renderInner = path => {
    const breadcrumbList = path.map(({ title: { translationKey, data }, href }, idx) => (
      <li key={idx}>
        <Link to={href}>{this.props.t(translationKey, data)}</Link>
      </li>
    ));

    const breadcrumbs = <ul className="breadcrumb">{breadcrumbList}</ul>;

    return breadcrumbs;
  };

  render() {
    return <BreadcrumbsContext.Consumer>{this.renderInner}</BreadcrumbsContext.Consumer>;
  }
}

export default withTranslation()(Breadcrumbs);
